import React, { useState } from 'react';
import { theme } from 'kb-shared';
import styled from 'styled-components';

import SegmentedControl from './SegmentedControl';
import useUserAge from 'hooks/useUserAge';
import useResults from 'hooks/useResults';
import { ReactComponent as SVGHeader } from 'assets/icons/calculator-header.svg';
import EggCountCalculator from './EggCountCalculator';
import LiveBirthCalculator from './LiveBirthCalculator';

export enum CalcType {
  Egg = 'Egg count',
  LiveBirth = 'Live birth'
}

const allCalculators: CalcType[] = [CalcType.Egg, CalcType.LiveBirth];

const CalculatorsWidget = () => {
  const [selectedCalculator, setSelectedCalculator] = useState<CalcType>(CalcType.Egg);
  const userAge = useUserAge();
  const results = useResults();

  return (
    <Container>
      <SVGHeader />
      <Title>Fertility Calculators</Title>
      <SegmentedControl
        options={allCalculators}
        selected={selectedCalculator}
        onSelect={(option: React.SetStateAction<CalcType>) => setSelectedCalculator(option)}
      />
      {selectedCalculator === CalcType.Egg && (
        <EggCountCalculator
          userAge={userAge}
          afcResult={results.afcResult}
          amhResult={results.amhResult}
        />
      )}
      {selectedCalculator === CalcType.LiveBirth && <LiveBirthCalculator userAge={userAge} />}
    </Container>
  );
};

export default CalculatorsWidget;

const Container = styled.div`
  ${({ theme }) => theme.grid.container};
  padding-top: 20px;
  padding-bottom: 28px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.beige};

  & > svg {
    margin: 0 auto;
  }
`;
const Title = styled.div`
  width: 100%;
  margin-top: 12px;
  margin-bottom: 20px;
  ${theme.fonts.DomaineDisplay};
  font-size: 24px;
  text-align: center;
`;
